// extracted by mini-css-extract-plugin
export default {"wrapper":"Sb5zuvItgmWG4_trWbWz"};